import React from 'react';
import TroubleCallList from './troublecalllist';  // Ensure this is the correct path
import TroubleCallForm from './troublecallform';


const TroubleCallEntry = () => {
    return (
        <div className='grid grid-cols-5 mx-auto items-center justify-center pt-2'>
            <div className='col-span-1 mx-auto w-full gradient-bg rounded-r-2xl border-2 border-gray-500 shadow-2xl'>
                <TroubleCallForm />
            </div>
            <div className='col-span-4 mx-auto w-full'>
                <TroubleCallList />
            </div>
        </div>
    );
};

export default TroubleCallEntry;